import { BAR_CODE } from "./configConstants";
import { isEmptyNumber, isEmptyString } from "./validations";

export const getObjectById = (arr, id) => {
    return arr.find(ar => ar.id === id);
}

export const getLabel = (value, statusObject) => {
    if (statusObject) {
        let result;

        if (statusObject.formData) {
            result = statusObject.formData.find(dt => dt.id === value || dt.status === value);

            return result ? result.label : ''
        } else {
            result = statusObject.find(dt => dt.id === value || dt.status === value);

            return result ? result.label : ''
        }
    } else {

        return value;
    }

}

export const formatCurrency = (value, currency) => {
    return (currency ? currency : 'LKR ') + parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const formatNumber = (value) => {
    return !isEmptyNumber(value) ? value : 0
}

export const getNetTotal = (total, shippingFee, discount = 0) => {
    let productValue = parseFloat(total);

    if (productValue <= 5000) {
        productValue = productValue + shippingFee
    }

    return productValue - discount;
}

export const getDiscountedPrice = (realPrice, discount) => {
    return realPrice - discount
}

export const getProductBarCode = (productId) => {
    return [BAR_CODE.productPrefix, productId].join('-')
}

export const getInventoryBarCode = (inventoryId) => {
    return [BAR_CODE.inventoryPrefix, inventoryId].join('-')
}

// This is a test utility function to fetch image from the server
export async function loadImage(url) {
    const imageUrl = "http://localhost:3000/api/media/eventMedia/" + url;

    const response = await fetch(imageUrl, {
        headers: {
            Authorization: "Bearer " + sessionStorage.getItem('token'), // Replace with actual token
        }
    });

    if (!response.ok) {
        console.error("Failed to fetch image");
        return;
    }

    const blob = await response.blob(); // Convert response to image blob
    return URL.createObjectURL(blob);
}